const comments = [
  {
    name: '影迷小李',
    content: '这个网站真的太好用了，资源全而且更新特别快，热播剧当天就能看到更新。画质也很清晰，比我之前用的好几个网站都好，已经推荐给身边的朋友都在用了。',
    rating: 5,
    date: '3天前',
  },
  {
    name: '追剧达人',
    content: '作为重度追剧爱好者，农民影视是我用过最流畅的免费高清影视网站。分类清晰找片方便，播放不卡顿，手机看也很舒服，真的是良心平台。',
    rating: 5,
    date: '5天前',
  },
  {
    name: '电影发烧友',
    content: '纪录片频道更新了很多高分作品，终于找到一个不需要注册就能免费看高清电影的地方了。希望平台越来越好，资源越来越多！',
    rating: 5,
    date: '1周前',
  },
  {
    name: '上班族小王',
    content: '每天通勤路上用手机看剧，画面自动适配屏幕大小，加载速度也很快。跟同事聊天推荐的很多小成本佳作都能在这里找到，太惊喜了。',
    rating: 4,
    date: '1周前',
  },
  {
    name: '家有萌娃',
    content: '少儿区内容很丰富，家长放心让孩子看。动画片画质清晰又没有乱七八糟的广告弹窗，孩子很喜欢，我也省心。如果能增加更多启蒙类节目就更好了。',
    rating: 5,
    date: '2周前',
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`text-xs ${star <= count ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      ))}
    </div>
  );
}

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            用户评论
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听在农民影视免费看高清电视剧的用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {comments.map((comment) => (
            <article
              key={comment.name}
              className="bg-white rounded-xl p-5 border border-background-200/70 hover:shadow-md transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 text-sm font-heading">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">{comment.name}</h3>
                  <time className="text-xs text-foreground-500">{comment.date}</time>
                </div>
              </div>
              <Stars count={comment.rating} />
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-3 line-clamp-5">
                {comment.content}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}